<script lang="ts">
	// Design system components
	import { Collapse } from '@Shelly/shelly-design-system';
	// Helpers
	import { capFirstChar, deepCopy } from 'src/helpers/utilities';
	import { getPeripheralDeviceStatus } from 'src/helpers/addons/addon_device_helpers';
	// Config
	import { getPeripheralSettings } from 'src/helpers/addons/addon_settings_helpers';
	// Components
	import PeripheralDeviceSetting from './PeripheralDeviceSetting.svelte';
	// Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	const peripheral = getPeripheralDeviceStatus(device)?.[0];
	const settings = deepCopy(peripheral.settings);
	const collapseSubMenu = getPeripheralSettings(peripheral, settings).map(
		({ settingType, title }) => ({
			component: PeripheralDeviceSetting,
			title,
			props: { device, peripheral, settingType, settings },
			expanded: false,
		}),
	);
</script>

{#each collapseSubMenu as { title, component, props, expanded }}
	<Collapse
		id="collapse-zmuyojq"
		title={capFirstChar(title)}
		class="mb-s"
		{expanded}
		on:click={() => {
			collapseSubMenu.forEach((i) => (i.expanded = false));
			expanded = !expanded;
		}}
	>
		<svelte:component this={component} {...props} />
	</Collapse>
{/each}
